"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoTriangle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const logo_triangle_style_1 = __importDefault(require("./logo.triangle.style"));
class LogoTriangle extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, axis, size, fillWhite } = this.props;
            const style = {
                width: axis === 'x' ? size || '100%' : 'auto',
                height: axis === 'y' ? size || '100%' : 'auto'
            };
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: "1.41421", clipRule: "evenodd", viewBox: "0 0 353 306", "aria-hidden": "true", className: classes.root, style: style }, { children: jsx_runtime_1.jsx("path", { "data-fill-white": fillWhite, className: classes.type, d: "M291.128 305.998h-46.51l-.176-.418v.42H104.174v-.002H61.872l98.959-232.7h31.338l98.959 232.7zm-63.232-39.583l-5.047-11.947-17.152-39.892-29.358-68.809-29.366 68.809-16.822 39.892-5.047 11.947h102.792zm16.546-226.83H104.174V0h140.268v39.585z" }, void 0) }), void 0));
        };
    }
}
exports.LogoTriangle = LogoTriangle;
LogoTriangle.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    axis: prop_types_1.default.oneOf(['x', 'y']),
    size: prop_types_1.default.number,
    fillWhite: prop_types_1.default.bool
};
LogoTriangle.defaultProps = {
    axis: 'x',
    size: null,
    fillWhite: false
};
exports.default = react_jss_1.default(logo_triangle_style_1.default)(LogoTriangle);
//# sourceMappingURL=logo.triangle.js.map